// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';

// import iconCaretLeft from "../../../assets/media/icon-caret-left.svg";
// import iconCaretRight from "../../../assets/media/icon-caret-right.svg";
// import iconCaretDown from "../../../assets/media/icon-caret-down.svg";

// function Pagination({ setCurrentPage, currentPage = 1, totalPages, itemsPerPage = 10 }) {
//     const [_currentPage, _setCurrentPage] = useState(currentPage);
//     const [_totalPages, _setTotalPages] = useState(totalPages);
//     const [_itemsPerPage, _setItemsPerPage] = useState(itemsPerPage);
//     const pageNumbers = Array.from({ length: _totalPages }, (_, index) => index + 1);

//     const handlePageClick = (pageNumber) => {
//         if (pageNumber > 0 && pageNumber < _totalPages + 1) {
//             _setCurrentPage(Number(pageNumber));
//             setCurrentPage(Number(pageNumber));
//         }
//     };

//     return (
//         <div className='boardFooter'>
//             <div className='pagination'>
//                 <Link
//                     className={`disabled ${_currentPage > 1 ? 'active' : 'hidden'}`}
//                     onClick={() => handlePageClick(_currentPage - 1)}
//                 >
//                     <img src={iconCaretLeft} alt='' />
//                 </Link>
//                 {[...Array(totalPages())].map((_, i) => (
//                     <Link
//                         key={i}
//                         className={`${_currentPage === i + 1 ? 'active' : ''}`}
//                         onClick={() => handlePageClick(i + 1)}
//                     >
//                         {i + 1}
//                     </Link>
//                 ))}
//                 <Link
//                     className={`disabled ${_currentPage < _totalPages ? 'active' : 'hidden'}`}
//                     onClick={() => handlePageClick(_currentPage + 1)}
//                 >
//                     <img src={iconCaretRight} alt='' />
//                 </Link>
//                 <Link className='wAuto'>
//                     {_itemsPerPage} / page <img className='ml-6' src={iconCaretDown} alt='' />
//                 </Link>
//                 <span>Goto</span>
//                 <input type='number' min={1} max={_totalPages} onChange={(e) => handlePageClick(e.target.value)} />
//             </div>
//         </div>
//     );
// }


// export default Pagination;

import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

import iconCaretLeft from "../../../assets/media/icon-caret-left.svg";
import iconCaretRight from "../../../assets/media/icon-caret-right.svg";
import iconCaretDown from "../../../assets/media/icon-caret-down.svg";

function Pagination({ setCurrentPage, currentPage = 1, totalPages, itemsPerPage = 10, setItemsPerPage }) {
    const [_currentPage, _setCurrentPage] = useState(currentPage);
    const [_itemsPerPage, _setItemsPerPage] = useState(itemsPerPage);
    const [gotoPage, setGotoPage] = useState('');
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);

    // Sync internal state with parent state
    useEffect(() => {
        _setCurrentPage(currentPage);
    }, [currentPage]);

    useEffect(() => {
        _setItemsPerPage(itemsPerPage);
    }, [itemsPerPage]);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handlePageClick = (pageNumber) => {
        const totalPagesCount = typeof totalPages === 'function' ? totalPages() : totalPages;
        if (pageNumber > 0 && pageNumber <= totalPagesCount) {
            _setCurrentPage(Number(pageNumber));
            setCurrentPage(Number(pageNumber));
        }
    };

    const handleGotoPage = (e) => {
        const pageNumber = parseInt(e.target.value);
        if (pageNumber && pageNumber > 0) {
            handlePageClick(pageNumber);
            setGotoPage('');
        }
    };

    const handleItemsPerPageChange = (newItemsPerPage) => {
        _setItemsPerPage(newItemsPerPage);
        setItemsPerPage(newItemsPerPage);
        setCurrentPage(1); // Reset to first page when changing items per page
        setShowDropdown(false);
    };

    const itemsPerPageOptions = [10, 30, 50, 100];

    const totalPagesCount = typeof totalPages === 'function' ? totalPages() : totalPages;

    console.log('Pagination component:', {
        currentPage: _currentPage,
        totalPagesCount,
        totalPagesType: typeof totalPages
    });

    return (
        <div className='boardFooter'>
            <div className='pagination'>
                <Link
                    className={`disabled ${_currentPage > 1 ? 'active' : 'hidden'}`}
                    onClick={() => handlePageClick(_currentPage - 1)}
                >
                    <img src={iconCaretLeft} alt='' />
                </Link>
                {[...Array(totalPagesCount)].map((_, i) => (
                    <Link
                        key={i}
                        className={`${_currentPage === i + 1 ? 'active' : ''}`}
                        onClick={() => handlePageClick(i + 1)}
                    >
                        {i + 1}
                    </Link>
                ))}
                <Link
                    className={`disabled ${_currentPage < totalPagesCount ? 'active' : 'hidden'}`}
                    onClick={() => handlePageClick(_currentPage + 1)}
                >
                    <img src={iconCaretRight} alt='' />
                </Link>
                <div className='dropdown d-inline-block mx-2' ref={dropdownRef}>
                    {itemsPerPageOptions.length > 0 && (
                        <select
                            value={_itemsPerPage}
                            onChange={(e) => handleItemsPerPageChange(Number(e.target.value))}
                            className="select-pagination"
                        >
                            {itemsPerPageOptions.map((option) => (
                                <option key={option} value={option}>
                                    {option} / page
                                </option>
                            ))}
                        </select>
                    )}
                </div>
                {/* <span>Goto</span>
                <input
                    type='number'
                    min={1}
                    max={totalPagesCount}
                    value={gotoPage}
                    onChange={(e) => setGotoPage(e.target.value)}
                    onKeyPress={(e) => e.key === 'Enter' && handleGotoPage(e)}
                    onBlur={handleGotoPage}
                /> */}
            </div>
        </div>
    );
}


export default Pagination;
